export default __webpack_public_path__ + "static/media/sketches.8006d278.jpeg";